/**
 * Active catalog owner for `X-Catalog-Owner`. Updated by CatalogProvider; read by
 * `client.ts` on every request. Null means "own inventory" (header omitted).
 */

let activeOwnerTelegramId: number | null = null;

export function setActiveCatalogOwner(telegramId: number | null): void {
  activeOwnerTelegramId = telegramId;
}

/** When null, the API scopes to the signed-in user. */
export function getActiveCatalogOwner(): number | null {
  return activeOwnerTelegramId;
}
